import type { Entity } from '@ots-frontend/ots-data';
import { RrcLocationProfilesPage } from '@ots-frontend/ots-ui-tw';
import type { CardProps } from '../Card/Card';
export type RrcLocationProfileDataTableCardProps = CardProps & {
  entity: Entity;
};
export const RrcLocationProfileDataTableCard = ({
  entity,
}: RrcLocationProfileDataTableCardProps) => (
  <RrcLocationProfilesPage
    locationId={entity.id}
    locationType={entity.entityType}
    locationName={entity.displayName}
    embedded
  />
);
